import React, { useEffect, useMemo, useState } from "react";
import Datatable from "../../Components/Datatable";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from "../../../../../context/AuthContext";
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const AdminPackageList = () => {
    const { user } = useAuth();
    const { t } = useTranslation();

    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(true);
    const [corporateData, setCorporateData] = useState([]);
    const [individualData, setIndividualData] = useState([]);

    const handleEdit = (row) => {
        const path = row.isInvidual
            ? "/admin/packageedit/individual/"
            : "/admin/packageedit/corporate/";
        window.location.href = path + row.id;
    };

    const buildColumns = (showStudentLimit = true, referenceLabel = "Kurs") =>
        [
            {
                Header: "Adı",
                Footer: "Adı",
                accessor: "packageName",
            },
            {
                Header: "Açıklama",
                Footer: "Açıklama",
                accessor: "packageDetail",
            },
            {
                Header: referenceLabel,
                Footer: referenceLabel,
                accessor: (originalRow) => (
                    <span dangerouslySetInnerHTML={{ __html: originalRow.referenceName }} />
                ),
                id: "referenceName",
            },
            {
                Header: "Fiyat",
                Footer: "Fiyat",
                accessor: "packagePrice",
            },
            showStudentLimit && {
                Header: t("studentCount"),
                Footer: t("studentCount"),
                accessor: "studentLimit",
            },
            {
                Header: t("validityDate"),
                Footer: t("validityDate"),
                accessor: "howManyDays",
            },
            {
                Header: t("isActive"),
                Footer: t("isActive"),
                accessor: "isActive",
            },
            {
                Header: t("editCourse"),
                accessor: (originalRow) => (
                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-info btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t("editPackage")}
                        </button>
                    </div>
                ),
                id: "actionEdit",
                Footer: t("editCourse"),
            },
        ].filter(Boolean);

    const corporateColumns = useMemo(() => buildColumns(true, "Bölüm"), [t]);
    const individualColumns = useMemo(() => buildColumns(false, "Kurs"), [t]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            try {
                const headers = {
                    accept: "*/*",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Credentials": "false",
                    Authorization: "Bearer " + user.token,
                };

                const packageUrl = API_BASE_URL + "/admin/Package/GetList";
                const courseUrl = API_BASE_URL + "/admin/CourseManager/GetCourses";
                const sectionUrl = API_BASE_URL + "/admin/SectionManager/GetList";
                const [packageRes, courseRes, sectionRes] = await Promise.all([
                    axios({
                        method: "GET",
                        url: packageUrl,
                        headers,
                    }),
                    axios({
                        method: "GET",
                        url: courseUrl,
                        headers,
                    }),
                    axios({
                        method: "GET",
                        url: sectionUrl,
                        headers,
                    }),
                ]);

                if (!(packageRes.status === 200 && packageRes.data?.success)) {
                    setMsg(packageRes.data?.message || "Paketler alınamadı.");
                    setLoading(false);
                    return;
                }

                const courseMap = {};
                if (courseRes.status === 200 && courseRes.data?.success) {
                    (courseRes.data.data || []).forEach((course) => {
                        courseMap[String(course.id)] = course.courseName;
                    });
                }

                const sectionMap = {};
                if (sectionRes.status === 200 && sectionRes.data?.success) {
                    (sectionRes.data.data || []).forEach((section) => {
                        sectionMap[String(section.id)] = section.sectionName;
                    });
                }

                const rows = (packageRes.data.data || []).map((item) => {
                    const isInvidual = !!item.isInvidual;
                    const referenceMap = isInvidual ? courseMap : sectionMap;
                    return {
                        id: item.id,
                        packageName: item.packageName,
                        packageDetail: item.packageDetail,
                        packagePrice: item.packagePrice,
                        studentLimit: item.studentLimit,
                        howManyDays: item.howManyDays,
                        isInvidual,
                        isActive: item.isActive ? t("active") : t("passive"),
                        referenceName: referenceMap[String(item.sortNumber)] || `#${item.sortNumber ?? "-"}`,
                    };
                });

                setCorporateData(rows.filter((row) => !row.isInvidual));
                setIndividualData(rows.filter((row) => row.isInvidual));
            } catch (err) {
                setMsg(err?.message || "Beklenmedik bir hata oluştu.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [t, user.token]);

    return (
        <div className="container-fluid py-3">
            <div style={{ textAlign: "center" }}>
                <h1>{t("packageList")}</h1>
                <h4>{msg}</h4>

                {loading && <div>Veriler yükleniyor...</div>}

                {!loading && (
                    <>
                        <div className="mb-5">
                            <h3 className="mb-3">Kurumsal Paketler</h3>
                            <Datatable
                                data={corporateData}
                                columns={corporateColumns}
                                tableBaslik="Kurumsal Paketler"
                            />
                        </div>

                        <div>
                            <h3 className="mb-3">Bireysel Paketler</h3>
                            <Datatable
                                data={individualData}
                                columns={individualColumns}
                                tableBaslik="Bireysel Paketler"
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default AdminPackageList;